import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import CirclePlusRegular from './circle-plus-regular-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <CirclePlusRegular {...validProps} />;
}
SvgComponent.iconName = 'circle-plus-regular-icon';

export const CirclePlusRegularIcon = svgIconWrapper(SvgComponent);
